import React from 'react';
import { TextField } from '@mui/material';

type TFProps = React.ComponentProps<typeof TextField>;

const FormField = React.forwardRef<any, TFProps>(({ sx, InputProps, ...rest }, ref) => {
  return (
    <TextField
      ref={ref}
      variant="outlined"
      fullWidth
      sx={{
        '& .MuiInputLabel-root': { color: (theme: any) => theme.palette.text.secondary },
        '& .MuiOutlinedInput-root': {
          background: (theme: any) => theme.palette.background.default,
          borderRadius: (theme: any) => theme.radii?.medium ?? 10,
          color: (theme: any) => theme.palette.text.primary,
          transition: 'all 0.22s ease',
          '& input': { color: (theme: any) => theme.palette.text.primary },
          '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
            WebkitTextFillColor: (theme: any) => theme.palette.text.primary,
            WebkitBoxShadow: (theme: any) => `0 0 0 1000px ${theme.palette.background.default} inset`,
            boxShadow: (theme: any) => `0 0 0 1000px ${theme.palette.background.default} inset`,
            caretColor: (theme: any) => theme.palette.text.primary,
            borderRadius: (theme: any) => theme.radii?.medium ?? 10,
            transition: 'background-color 9999s ease-in-out 0s',
          },
          '& fieldset': { borderColor: 'rgba(255,255,255,0.06)' },
          '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.12)' },
          '&.Mui-focused fieldset': { borderColor: (theme: any) => theme.palette.primary.main, borderWidth: 2 },
          '&.Mui-focused': { boxShadow: '0 8px 24px rgba(59,130,246,0.18)' },
        },
        ...sx,
      }}
      InputProps={{
        ...InputProps,
      }}
      {...rest}
    />
  );
});

FormField.displayName = 'FormField';

export default FormField;
